import { Flex, Input, Form, FormInstance } from 'antd'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl'
import { FormValues } from '../../types'
import { formKeys } from '../DonationForm/constants'
import { lang } from './lang'
import Toggle from '@/shared/components/Toggle'
import Label from '@/shared/components/Label'

type Props = {
  form: FormInstance<FormValues>
}

const rules = (intl: IntlShape) => [
  {
    required: true,
    message: intl.formatMessage(lang.required),
  },
]

export default function Name({ form }: Props) {
  const intl = useIntl()
  const isAnon = Form.useWatch<FormValues[typeof formKeys.isAnon]>(formKeys.isAnon, form) ?? {}

  const handleToggleAnon = (checked: boolean) => {
    if (checked) {
      form.resetFields([formKeys.name])
    }
  }

  const placeholder = isAnon ? intl.formatMessage(lang.anonPlaceholder) : intl.formatMessage(lang.namePlaceholder)

  return (
    <Flex vertical gap={4}>
      <Flex vertical gap={8}>
        <Form.Item
          name={formKeys.name}
          label={
            <Label>
              <FormattedMessage {...lang.nameTitle} />
            </Label>
          }
          rules={isAnon ? [] : rules(intl)}
        >
          <Input size="large" placeholder={placeholder} maxLength={20} showCount autoComplete="off" disabled={isAnon} />
        </Form.Item>
        <Form.Item name={formKeys.isAnon} noStyle>
          <Toggle label={intl.formatMessage(lang.remainAnon)} onChange={handleToggleAnon} size="small" />
        </Form.Item>
      </Flex>
    </Flex>
  )
}
